import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.css']
})
export class DocumentPreviewComponent {

  @Input() previewDocs: any[] = [];     // Array of { dataUrl, attachmentType, ... }
  @Input() showPopup: boolean = true;    // Controls modal visibility
  @Output() close = new EventEmitter<void>();

  currentIndex = 0;

  isPdf(fileUrl: string): boolean {
    return fileUrl?.toLowerCase().endsWith('.pdf');
  }

  nextSlide() {
    if (this.previewDocs.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
    }
  }

  prevSlide() {
    if (this.previewDocs.length > 0) {
      this.currentIndex =
        (this.currentIndex - 1 + this.previewDocs.length) % this.previewDocs.length;
    }
  }

  closePreview() {
    this.close.emit();
    this.currentIndex = 0;
  }

}
